
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block
}

.timeline {
  position: relative;
  border-left-width: 2px;
  border-color: var(--blue-responsible-lighten-3);
  padding-left: 1.5rem;
  padding-bottom: 2.5rem;
  border-left-style:solid
}

.timeline-event {
  position: relative;
  margin-bottom: 2.5rem
}

.timeline-event:last-child {
  margin-bottom: 0px
}

.last {
  margin-bottom: 0px
}

.circle {
  position: absolute;
  display: block;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 9999px;
  background-color: var(--blue-responsible-lighten-3);
  left:-31px
}

.circle.secondary {
  height: 0.65rem;
  width: 0.65rem;
  background-color: var(--blue-responsible-darken-2);
  left:-30px
}

.event-date {
  margin-bottom: 10px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--fw-bold)
}

.event-summary {
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-light)
}

.event-description {
  margin-top: 0px;
  font-size: var(--fs-base);
  line-height: var(--lh-base)
}

.arrow {
  position: absolute;
  height: 0.75rem;
  width: 0.75rem;
  border-right-width: 2px;
  border-top-width: 2px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-style: solid;
  border-color: var(--blue-responsible-lighten-3);
  bottom:0;
  left:-7px;
  transform:rotate(136deg)
}

.idb-color--default {
  color: var(--blue-responsible-darken-1)
}

.idb-color--blue {
  color: var(--blue-responsible-main)
}

.idb-color--blue-light {
  color: var(--blue-responsible-lighten-1)
}

.idb-color--blue-dark-1 {
  color: var(--blue-responsible-darken-1)
}

.idb-color--blue-dark-2 {
  color: var(--blue-responsible-darken-2)
}

.idb-color--gray {
  color: var(--gray-professional-main)
}

.idb-color--gray-light {
  color: var(--gray-professional-lighten-1)
}

.idb-color--gray-dark-1 {
  color: var(--gray-professional-darken-1)
}

.idb-color--gray-dark-2 {
  color: var(--gray-professional-darken-2)
}

.idb-color--cyan {
  color: var(--cyan-near-main)
}

.idb-color--cyan-light {
  color: var(--cyan-near-lighten-1)
}

.idb-color--cyan-dark-1 {
  color: var(--cyan-near-darken-1)
}

.idb-color--cyan-dark-2 {
  color: var(--cyan-near-darken-2)
}

.idb-color--white {
  color: var(--neutral-white)
}
`;